import { CreatedUser } from '@/interfaces/api/general/user';
import { Department } from '@/interfaces/model/general/department';

/**
 * 親が違えば同名の部署を作れる仕様なので、名前だけでは区別できない
 * (3 階層以上では直近の親も同名になりうるため、1 階層上の親名だけでも不十分)。
 * `departmentPathByUuid` (buildDepartmentPathMap が作るフルパス表) を渡すと、
 * ルートからのフルパスで区別する。
 */
export const getJoinedDepartmentName = (
  departments?: Department[],
  departmentPathByUuid?: Map<string, string>
): string => {
  if (!departments) return '';
  return departments
    .map(
      (department) =>
        departmentPathByUuid?.get(department.uuid) ?? department.name
    )
    .join(', ');
};

export const getFullName = (user?: CreatedUser, empty = '') => {
  if (!user) return empty;

  const nameParts = [user.last_name, user.middle_name, user.first_name]
    .filter(
      (part) => part != null && typeof part === 'string' && part.trim() !== ''
    )
    .map((part) => part.trim());

  return nameParts.length > 0 ? nameParts.join(' ') : empty;
};

export const countString = (value: string) => {
  // NOTES: use [...value].length instead of value.length
  // e.g.
  // TypeScript
  //   "🏴󠁧󠁢󠁥󠁮󠁧󠁿".length is 14;
  //   new Intl.Segmenter('ja', { type: 'grapheme' }).segment(🏴󠁧󠁢󠁥󠁮󠁧󠁿).length is 1;
  //   [...🏴󠁧󠁢󠁥󠁮󠁧󠁿].length is 7;
  // Python
  //   len(🏴󠁧󠁢󠁥󠁮󠁧󠁿) is 7;
  // PostgreSQL
  //   length(🏴󠁧󠁢󠁥󠁮󠁧󠁿) is 7;
  return [...value].length;
};

export const truncate = (value: string, length: number, omission = '...') => {
  if (countString(value) <= length) {
    return value;
  }
  return `${value.slice(0, length)}${omission}`;
};

export const parseDecimal = (value: string | number | null): number | null => {
  const parsedValue = parseFloat(`${value}`);
  return isNaN(parsedValue) ? null : parsedValue;
};
